import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { safeToLowerCase } from "../../../../../shared-functions/string";
import {
  getCurrentProjectID,
  toastError,
} from "../../../../../app_shared_functions";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsObject } from "../../../../../selectors/projects";
import useZoneId from "../../../../../custom-hooks/region/useZoneId";
import { TypedThunkDispatch } from "../../../../../reducers/thunk/type";
import { PredefinedParams } from "../../../../../components/slidingpanel/type";
import { buildBaseNetworkPayload } from "../../create/hooks/helpers";
import { createNetwork } from "../../actions";

const useNetworkDuplicateHandler = ({
  formData,
  predefined_params,
}: {
  formData: { [key: string]: any };
  predefined_params?: PredefinedParams;
}) => {
  const [isCreating, setIsCreating] = useState(false);

  const projects = useSelector(getProjectsObject);
  const zoneId = useZoneId(formData?.region || predefined_params?.region);
  const dispatch: TypedThunkDispatch = useDispatch();

  const duplicateNetwork = useCallback(() => {
    const region = safeToLowerCase(
      formData.region || predefined_params?.region,
    );
    const projectId = getCurrentProjectID(projects, region) || "";

    const networkPayload = {
      network: buildBaseNetworkPayload(formData, zoneId),
    };

    if (!formData.name) {
      networkPayload.network.name = predefined_params?.name;
    }

    setIsCreating(true);
    dispatch(createNetwork(region, projectId, networkPayload))
      .then(() => {
        toast.success("Duplicating network started...");
      })
      .catch((err) => {
        toastError(err, `Duplicating network failed!`);
      })
      .finally(() => {
        setIsCreating(false);
      });
  }, [
    formData,
    predefined_params?.region,
    predefined_params?.name,
    dispatch,
    projects,
    zoneId,
  ]);

  return {
    duplicateNetwork,
    isCreating,
  };
};

export default useNetworkDuplicateHandler;
